import {
  SHButton,
  SHDialog,
  SHStack,
  SHTypography,
} from "@components/design-systems";

interface CompleteAnalysisDialogProps {
  onClose?: () => void;
  onSubmit?: () => Promise<unknown>;
  isSubmitting?: boolean;
  isReview?: boolean;
}

export const CompleteAnalysisDialog = ({
  onClose,
  onSubmit,
  isSubmitting = false,
  isReview = false,
}: CompleteAnalysisDialogProps) => {
  return (
    <SHDialog
      open
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: { xs: "100%", md: 468 },
        },
      }}
      header={`Complete this ${isReview ? "review" : "analysis"}?`}
      body={
        <SHStack spacing={"25px"}>
          <SHTypography variant="body2" sx={{ fontSize: "16px" }}>
            {`You will not be able to make changes to this version of the ${
              isReview ? "review" : "analysis"
            }
            once completed.`}
          </SHTypography>
          <SHTypography variant="body2" sx={{ fontSize: "16px" }}>
            {`Please note: You can duplicate a completed ${
              isReview ? "review" : "analysis"
            } and continue
            working on the new version.`}
          </SHTypography>
        </SHStack>
      }
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            Yes, complete
          </SHButton>
        </SHStack>
      }
    />
  );
};
